// extracted by mini-css-extract-plugin
export default {"footer-button":"spellcheck-dialog_footer-button__3ZO0I","typography":"spellcheck-dialog_typography__U9LfE"};